// extracted by mini-css-extract-plugin
export default {"snackbar":"snackbar_snackbar__n7qNX"};